import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import './AdditionalDocs.scss';
import { useErrorsContext } from '../../../../contexts/ErrorsContext';
import { useEffect, useState } from 'react';
import { Button, Loading, NavMenu } from '../../../../components';
import { useParametrics } from '../../../../contexts/ParametricsContext';
import { PetitionCard } from '../../../../components/petitionCard/PetitionCard';
import { createAdditionalDocsProcedure, getAdditionalDocsProcedures } from '../../../../services/procedureServices';
import { AdditionalDocCard } from './AdditionalDocCard/AdditionalDocCard';
import { StatusUtils } from '../../../../utils';

const AdditionalDocs = () => {

  const { t } = useTranslation();
  const { convocation, convocationId } = useParametrics();
  const { showError } = useErrorsContext();
  const history = useHistory();
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const [creatingNewProcedure, setCreatingNewProcedure] = useState(false);
  const [petition, setPetition] = useState(null);
  const [additionalDocs, setAdditionalDocs] = useState(null);

  const petitionId = location?.state?.petition?.petitionId;

  const _getAdditionalDocs = async () => {
    try {
      setLoading(true);
      const resp = await getAdditionalDocsProcedures(petition.petitionId);
      setAdditionalDocs(resp);
    } catch (e) {
      showError(e);
    }
    finally{
      setLoading(false);
    }
  }

  useEffect(() => {
    if(!convocationId) return;
    if(!location?.state?.petition) {
      return history.replace('/petitions')
    }
    setPetition(location.state.petition);
  }, [convocationId]);

  useEffect(() => {
    if(petition) _getAdditionalDocs();
  }, [petition])

  const newProcedure = async () => {
    try {
      setCreatingNewProcedure(true);
      const {id: procedureId} = await createAdditionalDocsProcedure(petitionId);
      history.push(`/petitions/${petitionId}/additional-documents/new`, {
        additionalDocs: true, procedureId, petition,
      })
    } catch(e) {
      showError(e);
    } finally {
      setLoading(false);
      setCreatingNewProcedure(false);
    }
  }

  const showNewProcedureButton = ![
    StatusUtils.STATUS.ACCEPTED, StatusUtils.STATUS.REJECTED,
    StatusUtils.STATUS.PENDING_WITHDRAWAL, StatusUtils.STATUS.WITHDRAWAL,
  ].includes(petition?.processStatus.status)

  return (
    <NavMenu>
      <div className="AdditionalDocs">
        <div className="content">
          {
            loading ? (
              <div className='vh-100 d-flex justify-content-center align-items-center'>
                <Loading />
              </div>
            ) : (
              <>
                <div className="w-100 d-flex justify-content-center">
                  <div className="header">
                    <Button
                      icon="/misc/icons/arrow-left-blue.svg"
                      action={() => history.goBack()}
                      className="p-2 button-only-icon me-2"
                      a11y={t('Globals.return')}
                    />
                    <h1>{t('Petitions.additionalDocs.title')} </h1>
                  </div>
                </div>
                <div className="petitions">
                  <PetitionCard convocationTitle={convocation?.title} petition={petition} isButton={false}/>
                </div>
                {
                  showNewProcedureButton && (
                    <div className="new-procedure">
                      <Button
                          disabled={creatingNewProcedure}
                          className="buttonPrimaryLarge"
                          text={t('Petitions.additionalDocs.additionalDocsList.newProcedure')}
                          styles={{ backgroundColor: '#34fdfe', color: '#381940' }}
                          action={newProcedure}
                      />
                    </div>
                  )
                }
                <div className="additionalDocs">
                  {
                    additionalDocs.map((addDoc) => {
                      return (
                        <AdditionalDocCard
                          key={addDoc.id}
                          petition={petition}
                          addDoc={addDoc}
                        />
                      )
                    })
                  }
                </div>
              </>
            )
          }
        </div>
      </div>
    </NavMenu>
  );
}

export default AdditionalDocs;